// ===============================
// Brown Leopard Price Calculator
// ===============================

document.addEventListener("DOMContentLoaded", () => {

    // ---------- INPUTY ----------

    const hourRate = document.getElementById("hourRate");
    const shootHours = document.getElementById("shootHours");
    const photos = document.getElementById("photos");
    const editTime = document.getElementById("editTime");
    const km = document.getElementById("km");
    const kmPrice = document.getElementById("kmPrice");
    const communication = document.getElementById("communication");
    const otherCosts = document.getElementById("otherCosts");
    const reserve = document.getElementById("reserve");

    // ---------- VÝSTUPY ----------

    const editingTimeDisplay = document.getElementById("editingTimeDisplay");
    const reserveValue = document.getElementById("reserveValue");

    const shootingPrice = document.getElementById("shootingPrice");
    const editingPrice = document.getElementById("editingPrice");
    const travelPrice = document.getElementById("travelPrice");
    const communicationPrice = document.getElementById("communicationPrice");
    const otherCostsPrice = document.getElementById("otherCostsPrice");
    const reservePrice = document.getElementById("reservePrice");

    const totalPrice = document.getElementById("totalPrice");
    const resultPrice = document.getElementById("resultPrice");

    const totalHours = document.getElementById("totalHours");
    const realHourlyRate = document.getElementById("realHourlyRate");

    const resetButton = document.getElementById("resetCalculator");

    // ---------- POMOCNÉ FUNKCE ----------

    function number(input) {
        return Number(input.value) || 0;
    }

    function money(value) {
        return Math.round(value).toLocaleString("cs-CZ") + " Kč";
    }

    function hours(value) {

    let h = Math.floor(value);
    let m = Math.round((value - h) * 60);

    if (m === 60) {
        h++;
        m = 0;
    }

    return `${h} h ${m} min`;
}

   // ---------- SLIDER ----------

function updateSlider() {

    const value = Number(reserve.value);

    // Zobrazení hodnoty vpravo od nadpisu
    reserveValue.textContent = value + " %";

    const min = Number(reserve.min);
    const max = Number(reserve.max);

    const percent = ((value - min) / (max - min)) * 100;

    // Vybarvení slideru
    reserve.style.background = `
        linear-gradient(
            to right,
            #fab951 0%,
            #fab951 ${percent}%,
            #e8edf3 ${percent}%,
            #e8edf3 100%
        )
    `;

}
   // ---------- PŘEPOČET ----------

function calculate() {

    const rate = number(hourRate);
    const shoot = number(shootHours);
    const photoCount = number(photos);
    const editMinutes = number(editTime);
    const communicationHours = number(communication);
    const travelKm = number(km);
    const travelRate = number(kmPrice);
    const extras = number(otherCosts);
    const reservePercent = number(reserve);

    // EDITACE

    const editingHours = (photoCount * editMinutes) / 60;

    editingTimeDisplay.textContent = hours(editingHours);

    // CENY

    const shootCost = shoot * rate;
    const editingCost = editingHours * rate;
    const communicationCost = communicationHours * rate;
    const travelCost = travelKm * travelRate;

    const subtotal =
        shootCost +
        editingCost +
        communicationCost +
        travelCost +
        extras;

    const reserveCost = subtotal * (reservePercent / 100);

    const total = subtotal + reserveCost;

    // REZERVA

    reserveInfo.innerHTML =
        `+ <strong>${money(reserveCost)}</strong> k výsledné ceně`;

    // ČAS

    const workedHours =
        shoot +
        editingHours +
        communicationHours;

    const effectiveRate =
        workedHours > 0
            ? total / workedHours
            : 0;

    // VÝSTUPY

    shootingPrice.textContent = money(shootCost);
    editingPrice.textContent = money(editingCost);
    travelPrice.textContent = money(travelCost);
    communicationPrice.textContent = money(communicationCost);
    otherCostsPrice.textContent = money(extras);
    reservePrice.textContent = money(reserveCost);

    totalPrice.textContent = money(total);
    resultPrice.textContent = money(total);

    totalHours.textContent = hours(workedHours);

    realHourlyRate.textContent =
        money(effectiveRate) + " / hod.";

    updateSlider();
}
        // ---------- INPUTY ----------

    [
        hourRate,
        shootHours,
        photos,
        editTime,
        km,
        kmPrice,
        communication,
        otherCosts
    ].forEach(input => {
        input.addEventListener("input", calculate);
    });

    reserve.addEventListener("input", calculate);

    // ---------- RESET ----------

    resetButton.addEventListener("click", () => {

        [
            hourRate,
            shootHours,
            photos,
            editTime,
            km,
            kmPrice,
            communication,
            otherCosts
        ].forEach(input => {
            input.value = "";
        });

        reserve.value = 10;

        calculate();

    });

    // ---------- START ----------

    calculate();

});